/*
 * Authors: mariushirjanu
 * Created: 12/10/2021
 */
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { Transition } from '@uirouter/angular';
import { UserProfileComponent } from './user-profile.component';
import { UserProfileWrapperComponent } from './user-profile-wrapper.component';
import { STATE_USER_AUDIT, STATE_USER_INFO, STATE_USER_NOTIFICATIONS, STATE_USER_PERMISSIONS, STATE_USER_PROFILE, STATE_USER_TRAINING } from '../../shared/app-states';
import { UserInfoComponent } from './user-info/user-info.component';
import { UserProfileService } from './user-profile.service';
import { UserProfileDataService } from './userprofile-data.service';
import { SpendLimitInfoComponent } from './user-info/spend-limit-info.component';
import { SSOWarningComponent } from './user-info/sso-warning.component';
import { LocationEditComponent } from './user-info/location-edit.component';
import { ChangePasswordComponent } from './user-info/change-password.component';
import { UserPermissionsComponent } from './permissions/user-permissions.component';
import { PermissionsService } from './permissions/permissions.service';
import { CustomerPermissionsComponent } from './permissions/customer-permissions.component';
import { CustomerPermissionsDialogComponent } from './permissions/customer-permissions-dialog.component';
import { UserNotificationsComponent } from './notifications/user-notifications.component';
import { UserAuditComponent } from './audit/user-audit.component';
import { UserTrainingComponent } from './training/user-training.component';
import { GaStateDeclaration } from '../../../type_definitions/datatypes';

export const states:GaStateDeclaration[] = [
  {
    name: STATE_USER_PROFILE,
    abstract: true,
    url: '/userprofile?userId&webshopId&companyId&countryId',
    params: {
      userId: {
        dynamic: true
      }
    },
    views: {
      content: {
        component: UserProfileComponent,
        bindings: {
          userId: 'userId',
          companyId: 'companyId',
          countryId: 'countryId',
          webshopId: 'webshopId'
        }
      }
    },
    data: {
      translate: true
    },
    resolve: [
      {
        token: 'userId',
        deps: [ Transition ],
        resolveFn: (trans:Transition) => trans.params().userId
      },
      {
        token: 'companyId',
        deps: [ Transition ],
        resolveFn: (trans:Transition) => trans.params().companyId
      },
      {
        token: 'countryId',
        deps: [ Transition ],
        resolveFn: (trans:Transition) => trans.params().countryId
      },
      {
        token: 'webshopId',
        deps: [ Transition ],
        resolveFn: (trans:Transition) => trans.params().webshopId
      }
    ]
  },
  {
    name: STATE_USER_INFO,
    url: '',
    component: UserInfoComponent,
    data: {
      viewTitle: 'User Info',
      noMaxWidth: true,
      validate: [
        'SAVE_PROFILE',
        'APPROVE'
      ]
    }
  },
  {
    name: STATE_USER_PERMISSIONS,
    url: '/permissions',
    component: UserPermissionsComponent,
    data: {
      viewTitle: 'Permissions',
      noMaxWidth: true,
      validate: [
        'SAVE_PROFILE',
        'APPROVE'
      ]
    }
  },
  {
    name: STATE_USER_NOTIFICATIONS,
    url: '/notifications',
    component: UserNotificationsComponent,
    data: {
      viewTitle: 'Notifications',
      noMaxWidth: true
    }
  },
  {
    name: STATE_USER_AUDIT,
    url: '/audit',
    component: UserAuditComponent,
    data: {
      viewTitle: 'Audit',
      noMaxWidth: true
    }
  },
  {
    name: STATE_USER_TRAINING,
    url: '/training',
    component: UserTrainingComponent,
    data: {
      viewTitle: 'Training',
      noMaxWidth: true
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({ states }),
    CommonModule,
    SharedModule
  ],
  declarations: [
    UserProfileComponent,
    UserInfoComponent,
    UserPermissionsComponent,
    UserNotificationsComponent,
    UserAuditComponent,
    UserTrainingComponent,
    //--
    UserProfileWrapperComponent,
    SpendLimitInfoComponent,
    SSOWarningComponent,
    LocationEditComponent,
    ChangePasswordComponent,
    CustomerPermissionsComponent,
    CustomerPermissionsDialogComponent
  ],
  providers: [
    PermissionsService,
    UserProfileService,
    UserProfileDataService,
    { provide: 'UserTrainingComponent', useClass: UserTrainingComponent }
  ],
  exports: [
    UserProfileComponent
  ],
  // disable build errors in order to be able to use wizard-actions-before and wizard-actions-after in user-profile.component.ts; delete the next line after wizard-wrapper is upgraded to ng2
  schemas: [ NO_ERRORS_SCHEMA ]
})
export class UserProfileModule {
}